import React, { useEffect, useState, useRef } from "react";
import { QRCode } from "react-qrcode-logo";
import { QRProps } from "./types";

const StyledQR: React.FC<QRProps> = ({ url }) => {
  const [value, setValue] = useState(url);
  const [qrImage, setQrImage] = useState<string>("");
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    setValue(url);
  }, [url]);

  useEffect(() => {
    // Wait for QR code to render, then find and convert canvas to image
    const timer = setTimeout(() => {
      if (containerRef.current) {
        const canvas = containerRef.current.querySelector("canvas");
        if (canvas) {
          const imageUrl = canvas.toDataURL("image/png");
          setQrImage(imageUrl);
        }
      }
    }, 100);

    return () => clearTimeout(timer);
  }, [value]);

  return (
    <div style={{ textAlign: "center" }}>
      {/* Hidden QR Code generator */}
      <div ref={containerRef} style={{ position: "absolute", left: "-9999px" }}>
        <QRCode
          value={value}
          size={250}
          qrStyle="dots"
          fgColor="#09517d"
          bgColor="#FFFFFF"
          eyeColor="#09517d"
          //logoImage="/media/images/VerosLogo.jpg"
          logoWidth={70}
          logoHeight={70}
          removeQrCodeBehindLogo
        />
      </div>

      {/* Display as img tag */}
      {qrImage && (
        <img
          src={qrImage}
          alt="Scan QR code with your mobile phone to upload documents"
          className="w-full h-auto rounded-lg"
        />
      )}
    </div>
  );
};

export default StyledQR;
